import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { useDebounce } from "use-debounce"
import { searchPlayer } from "../../../services/players.services"
import Content from "../../../components/Content"
import TeamInterface from "../../../interfaces/Team.interface"
import { getAllTeams, searchTeam } from "../../../services/team.services"
import TeamListItem from "../../../components/TeamListItem"
import Loader from "../../../components/Loader"

const TeamsPage = () => {
    const [teams, setTeams] = useState<TeamInterface[]>([])
    const [loading, setLoading] = useState<boolean>(true)

    const [search, setSearch] = useState<string>("")
    const [result, setResult] = useState<TeamInterface[]>([])

    const [searchValue] = useDebounce(search, 500)


    const handleSearch: React.ChangeEventHandler<HTMLInputElement> = (event) => setSearch(event.target.value)

    useEffect(() => {
        getAllTeams()
            .then((res) => {
                setTeams(res.data.payload.teams)
            })
            .catch(() => {
                toast.error("Ha ocurrido un error :/")
            })
            .finally(() => setLoading(false))
    }, [])

    useEffect(() => {
        if (searchValue.length > 0) {
            setLoading(true)
            searchTeam({ search: searchValue })
                .then((res) => setResult(res.data.payload.result))
                .catch((error) => toast.error(error.response.data.message))
                .finally(() => setLoading(false))
        }
    }, [searchValue])

    return (

        <Content className="flex flex-col gap-10">
            <input
                className="px-5 h-[45px] border rounded outline-none"
                type="text"
                name="name"
                onChange={handleSearch}
                placeholder="Buscar por nombre"
                autoComplete="off"
            />

            {loading && <Loader />}
            {!loading && search.length > 0 &&
                <>
                    {result.length > 0 ?
                        result.map((team) => <TeamListItem key={team.id} team={team} />)
                        : <p className="text-sm uppercase text-zinc-700">No se encontró lo que buscabas</p>
                    }
                </>
            }
            {!loading && search.length === 0 &&

                <>
                    {teams.length > 0 ?
                        teams.map((team) => <TeamListItem key={team.id} team={team} />)
                        : <p className="text-sm uppercase text-zinc-700">No hay equipos creados</p>
                    }
                </>
            }
        </Content>

    )
}

export default TeamsPage